import React, { Fragment, Component } from 'react';

import Core from './../../Core/Core'
import ErrorManager from '../../Core/ErrorManager';

import UserModal from './UserModal';

class Users extends Component
{
    constructor(props)
    {
        super(props);

        this.delete = this.delete.bind(this);
    }

    delete(id)
    {
        if(!window.confirm("Etes-vous sûr de vouloir supprimer cet élément ?"))
            return;
        Core.Instance.Request(Core.Address+"User/"+id, null, "DELETE").then((json)=> {
            ErrorManager.Instance.Info("L'élément a bien été supprimé.");
            window.location.reload();
        });
    }

    render()
    {
        let index = 0;
        let users = !Array.isArray(this.props.users) ? [] :
        this.props.users.map((e) => {
            index++;
            let date = e.last != null ? (new Date(e.last*1000)) : null;
            if(date != null)
                date = date.getDate().toString().padStart(2,"0")+"/"+(date.getMonth()+1).toString().padStart(2,"0")+"/"+date.getFullYear()+" "+date.getHours().toString().padStart(2,"0")+":"+date.getMinutes().toString().padStart(2,"0");
            return (
                <tr key={index}>
                    <td>{ index }</td>
                    <td>{ e.email }</td>
                    <td>{ e.ip }</td>
                    <td>{ e.flash_access ? "Oui" : "Non" }</td>
                    <td>
                        { date }
                    </td>
                    {
                        this.props.editing == true && 
                        <td>
                            <a className="text-secondary" data-toggle="modal" data-target={ "#user"+e.id }>
                                <i className="far fa-eye"></i>
                            </a>
                            <span className='fas fa-edit ml-2' onClick={ (ev) => { ev.preventDefault();this.props.loadUser(e.id) }}/>
                            <span className='far fa-trash-alt ml-2' onClick={ (ev) => { ev.preventDefault();this.delete(e.id) } }/>
                        </td>
                    }
                </tr>
            );
        });
        //Modals
        index = 0;
        let modals = this.props.users == null ? [] :
        this.props.users.map((e) => {
            index++;
            return (<UserModal index={e.id} key={e.id} user={e}/>);
        });
        return (
            <Fragment>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Email</th>
                            <th>Ip</th>
                            <th>Accès flash</th>
                            <th>Dernière connexion</th>
                            {
                                this.props.editing == true &&
                                <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        { users }
                    </tbody>
                    
                </table>
                { modals }
            </Fragment>
        );
    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/Components/User/Users.js